import { TRACKER_IDS } from 'components/Trackers/trackerIDs'

type ButtonTappedEventFields = {
  object_name: string
  screen: string
  screen_name: string
  cta_title?: string
  feature?: string
  event_description?: string
}

const buttonTappedEvents = new Map<string, ButtonTappedEventFields>([
  [
    TRACKER_IDS.CONTACT_INFO.NEXT_BUTTON,
    {
      cta_title: 'Next',
      object_name: 'registrationInformationContactNext',
      screen: 'registrationInformationContact',
      screen_name: 'registrationInformationContact',
    },
  ],
  [
    TRACKER_IDS.CHOOSE_FUNDING_SOURCE.CONTINUE_BUTTON,
    {
      object_name: 'registrationLinkBankSelectCheckingAccount',
      screen: 'registrationLinkBankSelectChecking',
      screen_name: 'registrationLinkBankSelectChecking',
      cta_title: 'Continue',
    },
  ],
  [
    TRACKER_IDS.ESG_TOUR.CENTER_BUTTON,
    {
      cta_title: 'Lets Go or Done',
      object_name: 'registrationEsgTourLetsGoOrDone',
      screen: 'registrationEsgTour',
      screen_name: 'registrationEsgTour',
    },
  ],
  [
    TRACKER_IDS.ESG_TOUR.X_BUTTON,
    {
      cta_title: 'X',
      object_name: 'registrationEsgTourXButton',
      screen: 'registrationEsgTour',
      screen_name: 'registrationEsgTour',
    },
  ],
  [
    TRACKER_IDS.ESG_TOUR.RIGHT_ARROW,
    {
      cta_title: 'Right Arrow',
      object_name: 'registrationEsgTourRightArrow',
      screen: 'registrationEsgTour',
      screen_name: 'registrationEsgTour',
    },
  ],
  [
    TRACKER_IDS.ESG_TOUR.LEFT_ARROW,
    {
      cta_title: 'Left Arrow',
      object_name: 'registrationEsgTourLeftArrow',
      screen: 'registrationEsgTour',
      screen_name: 'registrationEsgTour',
    },
  ],
  [
    TRACKER_IDS.FUNDING.LINK_YOUR_BANK_BUTTON,
    {
      object_name: 'registrationLinkBankInterstitialNext',
      screen: 'registrationLinkBankInterstitial',
      screen_name: 'registrationLinkBankInterstitial',
      cta_title: 'Next',
    },
  ],
  [
    TRACKER_IDS.FUNDING.AUTOMATIC_BANK_LINK_BUTTON,
    {
      feature: 'Registration Link Bank: Interstitial',
      event_description: 'Link automatically button tapped',
      object_name: 'registrationLinkBankInterstitialLinkAutomatically',
      screen: 'registrationLinkBankInterstitial',
      screen_name: 'registrationLinkBankInterstitial',
    },
  ],
  [
    TRACKER_IDS.FUNDING.MANUAL_BANK_LINK_BUTTON,
    {
      feature: 'Registration Link Bank: Interstitial',
      event_description: 'Link manually button tapped',
      object_name: 'registrationLinkBankInterstitialLinkManually',
      screen: 'registrationLinkBankInterstitial',
      screen_name: 'registrationLinkBankInterstitial',
    },
  ],
  [
    TRACKER_IDS.INSTITUTIONS.MANUAL_LINK_BUTTON,
    {
      object_name: 'registrationLinkBankAccountManualCTA',
      screen: 'registrationLinkBankSearch',
      screen_name: 'registrationLinkBankSearch',
      cta_title: 'Link with routing/account number',
    },
  ],
  [
    TRACKER_IDS.INSTITUTIONS.SKIP_LINK_BANK_BUTTON,
    {
      object_name: 'registrationLinkBankSearchDoLater',
      screen: 'registrationLinkBankSearch',
      screen_name: 'registrationLinkBankSearch',
    },
  ],
  [
    TRACKER_IDS.INSTITUTIONS.SKIP_LINK_BANK_MODAL,
    {
      object_name: 'registrationLinkBankSearchDoLaterModal',
      screen: 'registrationLinkBankSearch',
      screen_name: 'registrationLinkBankSearch',
    },
  ],
  [
    TRACKER_IDS.INSTITUTIONS.SKIP_LINK_BANK_MODAL_CONFIRM,
    {
      object_name: 'registrationLinkBankSearchDoLaterConfirm',
      screen: 'registrationLinkBankSearch',
      screen_name: 'registrationLinkBankSearch',
    },
  ],
  [
    TRACKER_IDS.INSTITUTIONS.SKIP_LINK_BANK_MODAL_CANCEL,
    {
      object_name: 'registrationLinkBankSearchDoLaterCancel',
      screen: 'registrationLinkBankSearch',
      screen_name: 'registrationLinkBankSearch',
    },
  ],
  [
    TRACKER_IDS.INVEST_INTERSTITIAL.NEXT_BUTTON,
    {
      object_name: 'registrationInvestInterstitialNext',
      screen: 'registrationInvestInterstitial',
      screen_name: 'registrationInvestInterstitial',
      cta_title: 'Next',
    },
  ],
  [
    TRACKER_IDS.INVESTOR_QUESTIONS.SUBMIT_BUTTON,
    {
      object_name: 'registrationInformationInvestorQuestionsNext',
      screen: 'registrationInformationInvestorQuestions',
      screen_name: 'registrationInformationInvestorQuestions',
      cta_title: 'None of these apply to me',
    },
  ],
  [
    TRACKER_IDS.LATER_RECOMMENDATION.OPEN_BUTTON,
    {
      object_name: 'laterRegistrationIRARecommendationNext',
      screen: 'laterRegistrationIRARecommendation',
      screen_name: 'laterRegistrationIRARecommendation',
      cta_title: 'Open IRA Account',
    },
  ],
  [
    TRACKER_IDS.LATER_SUITABILITY_QUESTIONS.LATER_ONBOARDING_NEXT_BUTTON,
    {
      object_name: 'laterRegistrationInvestorQuestions',
      screen: 'laterRegistrationInvestorQuestions',
      screen_name: 'laterRegistrationInvestorQuestions',
      cta_title: 'Next',
    },
  ],
  [
    TRACKER_IDS.LATER_SUITABILITY_QUESTIONS.NEXT_BUTTON_1,
    {
      object_name: 'registrationPortfolioQuestionsPartOneNext',
      screen: 'registrationPortfolioQuestionsPartOne',
      screen_name: 'registrationPortfolioQuestionsPartOne',
      cta_title: 'Next',
    },
  ],
  [
    TRACKER_IDS.LATER_SUITABILITY_QUESTIONS.NEXT_BUTTON_2,
    {
      object_name: 'registrationPortfolioQuestionsPartTwoNext',
      screen: 'registrationPortfolioQuestionsPartTwo',
      screen_name: 'registrationPortfolioQuestionsPartTwo',
      cta_title: 'Next',
    },
  ],
  [
    TRACKER_IDS.MANUAL_FUNDING_SOURCE.ADD_FUNDING_SOURCE_BUTTON,
    {
      object_name: 'registrationLinkBankManualNext',
      screen: 'registrationLinkBankManual',
      screen_name: 'registrationLinkBankManual',
      cta_title: 'Add Funding Source',
    },
  ],
  [
    TRACKER_IDS.MANUAL_FUNDING_SOURCE.BACK_BUTTON,
    {
      feature: 'Registration Link Bank: Manual',
      event_description: 'Back button tapped',
      object_name: 'registrationLinkBankManualBack',
      screen: 'registrationLinkBankManual',
      screen_name: 'registrationLinkBankManual',
    },
  ],
  [
    TRACKER_IDS.MANUAL_FUNDING_SOURCE.SKIP_LINK_BANK_BUTTON,
    {
      object_name: 'registrationLinkBankManualDoLater',
      screen: 'registrationLinkBankManual',
      screen_name: 'registrationLinkBankManual',
    },
  ],
  [
    TRACKER_IDS.MANUAL_FUNDING_SOURCE.SKIP_LINK_BANK_MODAL,
    {
      object_name: 'registrationLinkBankManualDoLaterModal',
      screen: 'registrationLinkBankManual',
      screen_name: 'registrationLinkBankManual',
    },
  ],
  [
    TRACKER_IDS.MANUAL_FUNDING_SOURCE.SKIP_LINK_BANK_MODAL_CONFIRM,
    {
      object_name: 'registrationLinkBankManualDoLaterConfirm',
      screen: 'registrationLinkBankManual',
      screen_name: 'registrationLinkBankManual',
    },
  ],
  [
    TRACKER_IDS.MANUAL_FUNDING_SOURCE.SKIP_LINK_BANK_MODAL_CANCEL,
    {
      object_name: 'registrationLinkBankManualDoLaterCancel',
      screen: 'registrationLinkBankManual',
      screen_name: 'registrationLinkBankManual',
    },
  ],
  [
    TRACKER_IDS.PERSONAL_INFO.NEXT_BUTTON,
    {
      object_name: 'registrationInformationPersonalNext',
      screen: 'registrationInformationPersonal',
      screen_name: 'registrationInformationPersonal',
      cta_title: 'Next',
    },
  ],
  [
    TRACKER_IDS.PORTFOLIO_OVERVIEW.SUBMIT_BUTTON,
    {
      cta_title: 'Next',
      object_name: 'registrationPortfolioBreakdownNext',
      screen: 'registrationPortfolioBreakdown',
      screen_name: 'registrationPortfolioBreakdown',
    },
  ],
  [
    TRACKER_IDS.PORTFOLIO_SELECT_THEME.NEXT,
    {
      cta_title: 'Next',
      object_name: 'registrationPortfolioSelectThemeNext',
      screen: 'registrationPortfolioSelectTheme',
      screen_name: 'registrationPortfolioSelectTheme',
    },
  ],
  [
    TRACKER_IDS.PORTFOLIO_SELECT_THEME.LEARN_MORE,
    {
      cta_title: 'Learn More',
      object_name: 'registrationPortfolioSelectThemeLearnMore',
      screen: 'registrationPortfolioSelectTheme',
      screen_name: 'registrationPortfolioSelectTheme',
    },
  ],
  [
    TRACKER_IDS.SIGNUP.GET_STARTED_BUTTON,
    {
      object_name: 'registrationCreateAccountNext',
      screen: 'registrationCreateAccount',
      screen_name: 'registrationCreateAccount',
      cta_title: 'Get Started',
    },
  ],
  [
    TRACKER_IDS.SIGNUP.CREATE_ACCOUNT_BUTTON,
    {
      object_name: 'registrationCreateAccountPassword',
      screen: 'registrationCreateAccountPassword',
      screen_name: 'registrationCreateAccountPassword',
      cta_title: 'Create account',
    },
  ],
  [
    TRACKER_IDS.SIGNUP.COMPARE_SUBSCRIPTION_TIERS_BUTTON,
    {
      object_name: 'registrationCreateAccountCompareSubscriptionTiers',
      screen: 'registrationCreateAccount',
      screen_name: 'registrationCreateAccount',
      cta_title: 'Compare subscription tiers',
    },
  ],
  [
    TRACKER_IDS.SIGNUP.US_RESIDENT_AGREEMENT_BUTTON,
    {
      object_name: 'registrationCreateAccountResidentAndProgramAgreement',
      screen: 'registrationCreateAccount',
      screen_name: 'registrationCreateAccount',
    },
  ],
  [
    TRACKER_IDS.SSN.NEXT_BUTTON,
    {
      object_name: 'registrationSsnNext',
      screen: 'registrationSsn',
      screen_name: 'registrationSsn',
      cta_title: 'Next',
    },
  ],
  [
    TRACKER_IDS.START_INVESTING.CHANGE_ONE_TIME_AMOUNT,
    {
      object_name: 'registrationInitialInvestmentOneTimeAmount',
      screen: 'registrationInitialInvestmentOneTime',
      screen_name: 'registrationInitialInvestmentOneTime',
    },
  ],
  [
    TRACKER_IDS.START_INVESTING.CHANGE_RECURRING_AMOUNT,
    {
      object_name: 'registrationInitialInvestmentRecurringAmount',
      screen: 'registrationInitialInvestmentRecurring',
      screen_name: 'registrationInitialInvestmentRecurring',
    },
  ],
  [
    TRACKER_IDS.START_INVESTING.LATER_ONBOARDING_ONE_TIME_START_INVESTING,
    {
      cta_title: 'Invest',
      object_name: 'laterRegistrationOneTimeInvestmentNext',
      screen: 'laterRegistrationOneTimeInvestment',
      screen_name: 'laterRegistrationOneTimeInvestment',
    },
  ],
  [
    TRACKER_IDS.START_INVESTING.LATER_ONBOARDING_ONE_TIME_SKIP,
    {
      cta_title: 'Make One-Time Investment Instead',
      object_name: 'laterRegistrationOneTimeInvestmentSkip',
      screen: 'laterRegistrationOneTimeInvestment',
      screen_name: 'laterRegistrationOneTimeInvestment',
    },
  ],
  [
    TRACKER_IDS.START_INVESTING.LATER_ONBOARDING_RECURRING_SKIP,
    {
      cta_title: "I'll make an investment later",
      object_name: 'laterRegistrationRecurringInvestmentSkip',
      screen: 'laterRegistrationRecurringInvestment',
      screen_name: 'laterRegistrationRecurringInvestment',
    },
  ],
  [
    TRACKER_IDS.START_INVESTING.LATER_ONBOARDING_RECURRING_START_INVESTING,
    {
      cta_title: 'Invest',
      object_name: 'laterRegistrationRecurringInvestmentNext',
      screen: 'laterRegistrationRecurringInvestment',
      screen_name: 'laterRegistrationRecurringInvestment',
    },
  ],
  [
    TRACKER_IDS.START_INVESTING.ONE_TIME_SKIP,
    {
      cta_title: "I'll make an investment later",
      object_name: 'registrationInitialInvestmentOneTimeSkip',
      screen: 'registrationInitialInvestmentOneTime',
      screen_name: 'registrationInitialInvestmentOneTime',
    },
  ],
  [
    TRACKER_IDS.START_INVESTING.ONE_TIME_START_INVESTING,
    {
      cta_title: 'Invest',
      object_name: 'registrationInitialInvestmentOneTimeNext',
      screen: 'registrationInitialInvestmentOneTime',
      screen_name: 'registrationInitialInvestmentOneTime',
    },
  ],
  [
    TRACKER_IDS.START_INVESTING.RECURRING_SKIP,
    {
      cta_title: "I'll make an investment later",
      object_name: 'registrationInitialInvestmentRecurringSkip',
      screen: 'registrationInitialInvestmentRecurring',
      screen_name: 'registrationInitialInvestmentRecurring',
    },
  ],
  [
    TRACKER_IDS.START_INVESTING.RECURRING_START_INVESTING,
    {
      cta_title: 'Invest',
      object_name: 'registrationInitialInvestmentRecurringNext',
      screen: 'registrationInitialInvestmentRecurring',
      screen_name: 'registrationInitialInvestmentRecurring',
    },
  ],
  [
    TRACKER_IDS.SUITABILITY_QUESTIONS.NEXT_BUTTON,
    {
      cta_title: 'Next',
      object_name: 'registrationPortfolioQuestionsNext',
      screen: 'registrationPortfolioQuestions',
      screen_name: 'registrationPortfolioQuestions',
    },
  ],
  [
    TRACKER_IDS.SUCCESS.APP_STORE_BUTTON,
    {
      object_name: 'registrationSuccessAppStore',
      screen: 'registrationSuccess',
      screen_name: 'registrationSuccess',
      cta_title: 'App Store',
    },
  ],
  [
    TRACKER_IDS.SUCCESS.GOOGLE_PLAY_BUTTON,
    {
      object_name: 'registrationSuccessGooglePlay',
      screen: 'registrationSuccess',
      screen_name: 'registrationSuccess',
      cta_title: 'Google Play',
    },
  ],
  [
    TRACKER_IDS.SUCCESS.OPEN_APP_BUTTON,
    {
      object_name: 'registrationSuccessLogin',
      screen: 'registrationSuccess',
      screen_name: 'registrationSuccess',
      cta_title: 'Open Acorns',
    },
  ],
  [
    TRACKER_IDS.SUCCESS.EARLY_TIER.NEXT_BUTTON,
    {
      object_name: 'registrationSuccessEarlyTierNext',
      screen: 'registrationSuccess',
      screen_name: 'registrationSuccess',
      cta_title: 'Next',
    },
  ],
  [
    TRACKER_IDS.SUCCESS.EARLY_TIER.UNVERIFIED_BUTTON,
    {
      object_name: 'registrationSuccessEarlyTierUnverified',
      screen: 'registrationSuccess',
      screen_name: 'registrationSuccess',
      cta_title: 'Ok, got it',
    },
  ],
  [
    TRACKER_IDS.WELCOME.LATER_ONBOARDING_NEXT_BUTTON,
    {
      object_name: 'laterRegistrationInterstitialCTA',
      screen: 'laterRegistrationInterstitial',
      screen_name: 'laterRegistrationInterstitial',
      cta_title: 'Get Started',
    },
  ],
  [
    TRACKER_IDS.WELCOME.LATER_ONBOARDING_MODAL_CANCEL_BUTTON,
    {
      object_name: 'laterRegistrationUpgradeCancel',
      screen: 'laterRegistrationInterstitial',
      screen_name: 'laterRegistrationInterstitial',
      cta_title: 'Nevermind',
    },
  ],
  [
    TRACKER_IDS.WELCOME.LATER_ONBOARDING_MODAL_CONFIRM_BUTTON,
    {
      object_name: 'laterRegistrationUpgradeConfirm',
      screen: 'laterRegistrationInterstitial',
      screen_name: 'laterRegistrationInterstitial',
      cta_title: 'Upgrade',
    },
  ],
  [
    TRACKER_IDS.WELCOME.LATER_ONBOARDING_UNQUALIFIED_CANCEL_BUTTON,
    {
      object_name: 'laterRegistrationUnqualifiedModalCancel',
      screen: 'laterRegistrationInterstitial',
      screen_name: 'laterRegistrationInterstitial',
      cta_title: 'Cancel',
    },
  ],
  [
    TRACKER_IDS.WELCOME.LATER_ONBOARDING_UNQUALIFIED_CONFIRM_BUTTON,
    {
      object_name: 'laterRegistrationUnqualifiedModalConfirm',
      screen: 'laterRegistrationInterstitial',
      screen_name: 'laterRegistrationInterstitial',
      cta_title: 'Confirm',
    },
  ],
  [
    TRACKER_IDS.WELCOME.NEXT_BUTTON,
    {
      object_name: 'welcomeGetStarted',
      screen: 'welcome',
      screen_name: 'welcome',
      cta_title: 'Get Started',
    },
  ],
  [
    TRACKER_IDS.EVENT.SIGNUP,
    {
      object_name: 'event',
      screen: 'event',
      screen_name: 'event',
      cta_title: 'SignUp',
    },
  ],
  [
    TRACKER_IDS.SIGNUP.COMPARE_SUBSCRIPTION_TIERS_BUTTON,
    {
      cta_title: 'Compare subscription tiers',
      object_name: 'pricingInterstitalCompareTiers',
      screen: 'registrationPricingInterstital',
      screen_name: 'registrationPricingInterstital',
    },
  ],
  [
    TRACKER_IDS.PRICING_INTERSTITIAL.NEXT_BUTTON,
    {
      cta_title: 'Next button for pricing interstitial',
      object_name: 'pricingInterstitalNext',
      screen: 'PricingInterstitalNext',
      screen_name: 'PricingInterstitalNext',
    },
  ],
  [
    TRACKER_IDS.PERSONAL_INFO.BACK_BUTTON,
    {
      object_name: 'registrationInformationPersonalBack',
      screen: 'registrationInformationPersonal',
      screen_name: 'registrationInformationPersonal',
    },
  ],
  [
    TRACKER_IDS.CONTACT_INFO.BACK_BUTTON,
    {
      object_name: 'registrationInformationContactBack',
      screen: 'registrationInformationContact',
      screen_name: 'registrationInformationContact',
    },
  ],
  [
    TRACKER_IDS.ADDRESS_VALIDATION.RESIDENTIAL_ADDRESS_EDIT_BACK_BUTTON,
    {
      object_name: 'registrationResidentialAddressEditAddressBack',
      screen: 'registrationResidentialAddressEditAddress',
      screen_name: 'registrationResidentialAddressEditAddress',
    },
  ],
  [
    TRACKER_IDS.ADDRESS_VALIDATION.RESIDENTIAL_ADDRESS_NOT_FOUND_BACK_BUTTON,
    {
      object_name: 'registrationResidentialAddressNotFoundBack',
      screen: 'registrationResidentialAddressNotFound',
      screen_name: 'registrationResidentialAddressNotFound',
    },
  ],
  [
    TRACKER_IDS.ADDRESS_VALIDATION.RESIDENTIAL_ADDRESS_SUGGESTED_BACK_BUTTON,
    {
      object_name: 'registrationResidentialSuggestedAddressBack',
      screen: 'registrationResidentialSuggestedAddress',
      screen_name: 'registrationResidentialSuggestedAddress',
    },
  ],
  [
    TRACKER_IDS.ADDRESS_VALIDATION.SHIPPING_ADDRESS_PREVIEW_BACK_BUTTON,
    {
      object_name: 'registrationSpendAddressBack',
      screen: 'registrationSpendAddress',
      screen_name: 'registrationSpendAddress',
    },
  ],
  [
    TRACKER_IDS.ADDRESS_VALIDATION.SHIPPING_ADDRESS_NOT_FOUND_BACK_BUTTON,
    {
      object_name: 'bankCardOrderAddressNotFoundBack',
      screen: 'bankCardOrderAddressNotFound',
      screen_name: 'bankCardOrderAddressNotFound',
    },
  ],
  [
    TRACKER_IDS.ADDRESS_VALIDATION.SHIPPING_ADDRESS_EDIT_BACK_BUTTON,
    {
      object_name: 'bankCardOrderEditAddressInputBack',
      screen: 'bankCardOrderEditAddressInput',
      screen_name: 'bankCardOrderEditAddressInput',
    },
  ],
  [
    TRACKER_IDS.ADDRESS_VALIDATION.SHIPPING_ADDRESS_SUGGESTED_BACK_BUTTON,
    {
      object_name: 'bankCardOrderSuggestedAddressBack',
      screen: 'bankCardOrderSuggestedAddress',
      screen_name: 'bankCardOrderSuggestedAddress',
    },
  ],
  [
    TRACKER_IDS.CARD_SIGNATURE.BACK_BUTTON,
    {
      object_name: 'registrationSpendSignatureBack',
      screen: 'registrationSpendSignature',
      screen_name: 'registrationSpendSignature',
    },
  ],
])

// Given a location object, resolve to event metadata
export const getButtonTappedEvent = (buttonId: string) => {
  const eventData = buttonTappedEvents.get(buttonId)

  return eventData ?? {}
}
